import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import { Link } from 'react-router-dom'

const SyncBanner = ({ lastSync, pmsType }) => {
  if (moment().diff(moment(lastSync), 'days') < 1) {
    return null
  }

  const getMessageAndEmail = () => {
    switch (pmsType) {
      case 'topsOrtho':
        return {
          message: 'Please ensure your server is active as soon as possible.',
          email: 'support@topsortho.com',
          link: '', // No troubleshooting guide for OpenDental
          pmsDisplayName: 'Tops'
        }
      case 'Dolphin':
        return {
          message: "Please make sure your server is active as soon as possible.",
          email: 'support@dolphinimaging.com',
          link: '/troubleshooting/dolphin',
          pmsDisplayName: 'Dolphin'
        }
      case 'OpenDental':
        return {
          message: 'Please ensure your server is active as soon as possible.',
          email: 'service@opendental.com',
          link: '',  // No troubleshooting guide for OpenDental
          pmsDisplayName: 'Open Dental'
        }
      default:
        return null
    }
  }

  const messageAndEmail = getMessageAndEmail()
  if (!messageAndEmail) {
    return null
  }

  const { message, email, link, pmsDisplayName } = messageAndEmail
  
  return (
    <div style={{ backgroundColor: '#FFC3C3', padding: '10px', paddingLeft: '136px', color: '#640000' }}>
      <div>
        Your {pmsDisplayName} Practice last synced {new Date(lastSync).toLocaleDateString()}. {message}
        {' '}
        For help reach out to{' '}
        <a 
          href={`mailto:${email}`}
          style={{ color: '#4A0000', textDecoration: 'underline' }}
        >
          {email}
        </a>
        {link && (
          <span>
            {' '}
            or view our{' '}
            <Link
              to={link}
              style={{ color: '#4A0000', textDecoration: 'underline' }}
            >
              troubleshooting guide
            </Link>
          </span>
        )}
      </div>
    </div>
  )
}

SyncBanner.propTypes = {
  lastSync: PropTypes.string.isRequired,
  pmsType: PropTypes.string
}

export default SyncBanner 



// WEBPACK FOOTER //
// ./src/components/SyncBanner.js